import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=875f14b8"
import script from "./ProductBox.vue?vue&type=script&lang=ts"
export * from "./ProductBox.vue?vue&type=script&lang=ts"
import style0 from "./ProductBox.vue?vue&type=style&index=0&id=875f14b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports